// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { cogZoomed16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-cog-zoomed': IconCogZoomed;
    }
}

/**
 * The icon component for the 'cogZoomed' icon
 */
export class IconCogZoomed extends Icon {
    public constructor() {
        super(cogZoomed16X16);
    }
}

registerIcon('icon-cog-zoomed', IconCogZoomed);
export const iconCogZoomedTag = 'nimble-icon-cog-zoomed';
